import React from 'react'
import { CGE } from '../../../../common/components/CGE';
import ClayTable from "@clayui/table";

function ListEquipments({ props, showDeleteColumn = true }) {
    const arrTitle = [
        "Descripción de Equipo",
        "Potencia Nominal",
        "Horas de uso Diario",
        ...(showDeleteColumn ? ["Eliminar"] : [])
    ]

    return (
        <div id="cge-list-equipments" className="">
            <ClayTable
                class="table table-striped table-autofit show-quick-actions-on-hover table-list table-nowrap tbody-valign-middle thead-valign-middle table-valign-middle"
                id="table-to-xls"
            >
                <ClayTable.Head>
                    <ClayTable.Row>
                        {arrTitle?.map((title) => (
                            <ClayTable.Cell
                                className="clientCell font-weight-bold"
                                headingCell
                            >
                                {title}
                            </ClayTable.Cell>
                        ))}
                    </ClayTable.Row>
                </ClayTable.Head>
                <ClayTable.Body>
                    {props.listEquipUsed?.map((obj) => (
                        <ClayTable.Row className="tableRow">
                            {Object.keys(obj).map((key) => {
                                // Si no se debe mostrar la columna 'Eliminar', omitirla
                                if (!showDeleteColumn && key === "eliminar") return null;
                                return (
                                    <ClayTable.Cell
                                        className="txt-with-link clientCell-td table-cell-minw-150 table-cell-expand text-truncate"
                                        title={obj[key]?.length > 23 ? obj[key] : ""}
                                    >
                                        {key === "eliminar" ? (
                                            <div className="d-flex align-items-center justify-content-between">
                                                <CGE.Button
                                                    onClick={() => props.deleteObjListEquip(obj)}
                                                    type="secondary"
                                                    label="Eliminar"
                                                    size="sm"
                                                />
                                            </div>
                                        ) : (
                                            obj[key]
                                        )}
                                    </ClayTable.Cell>
                                );
                            })}
                        </ClayTable.Row>
                    ))}
                </ClayTable.Body>
            </ClayTable>
        </div>
    );
}
export default ListEquipments